const pl = {
  navigation: {
    button: "Dodaj nowy cel",
  },
  homepage: {
    headline: "Strona główna",
    description: "Przegląd wszystkich Twoich rocznych celów, kamieni milowych i życzeń w jednym miejscu.",
  },
  vision_board: {
    headline: "Tablica wizji",
    description: "Wizualny przegląd Twoich celów, aby pozostać zmotywowanym i skoncentrowanym.",
  },
  goals: {
    headline: "Cele",
    description: "Śledź swoje cele i nawyki, a także obserwuj postępy w czasie.",
    not_found: "Nie znaleziono celu",
    back_to_goals: "Powrót do celów",
    details_headline: "Szczegóły celu",
    details_description: "Zobacz szczegóły",
    edit_goal: "Edytuj cel"
  },
  milestones: {
    headline: "Kamienie milowe",
    description: "Śledź codzienne zadania i zapisuj notatki na temat swojego dnia w dzienniku.",
  },
  wishlist: {
    headline: "Lista życzeń",
    description: "Organizuj i śledź pożądane przedmioty i przyszłe zakupy.",
  },
  notification: {
    headline: "Powiadomienia",
    description: "Tutaj znajdziesz wszystkie aktualizacje.",
    empty: "Brak powiadomień."
  },  
  profile: {
    headline: "Profil",
    description: "Zobacz i zarządzaj swoimi danymi osobowymi oraz ustawieniami.",

    tab_1: "Informacje osobiste",
    tab_1_description: "Zaktualizuj swój profil, dane kontaktowe i preferencje, aby spersonalizować swoje doświadczenie.",
    tab_2: "Logowanie i bezpieczeństwo",
    tab_2_description: "Zaktualizuj swoje hasło i ustawienia logowania.",
    tab_3: "Subskrypcja i płatność",
    tab_3_description: "Zaktualizuj swoje hasło i ustawienia logowania.",
    button: "Usuń konto",

    card_title_login: "Dane logowania",
    card_description_login: "",
    card_title_pass: "Szczegóły hasła",
    card_description_pass: "",
    card_title_subscription: "Szczegóły subskrypcji",
    card_description_subscription: "Zaktualizuj swoje hasło i ustawienia logowania.",
    card_title_payment: "Szczegóły płatności",
    card_description_payment: "",

    popup: {
      delete_title: "Usuń konto",
      delete_description: "Czy na pewno chcesz usunąć swoje konto? Tej operacji nie można cofnąć. Usunięcie konta spowoduje również anulowanie subskrypcji.",
    },

  
    personal: {
      title: "Dane osobowe",
      form: {
        label_name: "Imię",
        label_surname: "Nazwisko",
        label_phone: "Numer telefonu",
        label_country: "Kraj",
        label_city: "Miasto/Województwo",
        label_postal: "Kod pocztowy",
        label_street: "Ulica",
        label_username: "Nazwa użytkownika",
        label_email: "Email",
        label_old_pass: "Wpisz stare hasło",
        label_new_pass: "Wpisz nowe hasło",
        label_new_pass_repeat: "Powtórz nowe hasło",
        label_cardholder: "Imię i nazwisko właściciela karty",
        label_cardnumber: "Numer karty",
        label_carddate: "Data ważności",
        label_cvv: "CVV / CVC (Kod weryfikacyjny karty)"
      }
    }
  },
  login: {
    headline: "Zaloguj się",
    description: "Wprowadź swoje dane",
  },
  register: {
    headline: "Załóż konto",
    description: "Wprowadź swoje dane",
    form: {
      label_email: "Email",
      placeholder_email: "info@niumi.dk",
      details_email: "Bez spamu, gwarantowane.",
      label_password: "Hasło",
      details_password: "Min. 12 znaków",
      label_confirm_password: "Potwierdź hasło",
      button_submit: "Rozpocznij darmowy okres próbny",
      button_resend: "Wyślij ponownie email weryfikacyjny",
      subheadline_enter_details: "Wprowadź swoje dane",
      subheadline_confirm_email: "Potwierdź swój email",
      description_confirm_email: "Wysłaliśmy Ci email weryfikacyjny. Sprawdź swoją skrzynkę i potwierdź adres email, aby kontynuować.",
      text_already_registered: "Masz już konto?",
      text_login: "Zaloguj się",
      text_or: "lub",
      terms_text_prefix: "Tworząc konto, akceptujesz nasze",
      terms_link: "Warunki korzystania z usługi",
      terms_text_and: "oraz",
      privacy_link: "Politykę prywatności"
    },
    errors: {
      invalid_email: "Wprowadź prawidłowy adres email",
      password_min_length: "Hasło musi mieć co najmniej 12 znaków",
      password_uppercase: "Hasło musi zawierać co najmniej jedną wielką literę",
      password_lowercase: "Hasło musi zawierać co najmniej jedną małą literę",
      password_number: "Hasło musi zawierać co najmniej jedną cyfrę",
      password_special: "Hasło musi zawierać co najmniej jeden znak specjalny",
      confirm_password_required: "Potwierdź swoje hasło",
      passwords_do_not_match: "Hasła nie są zgodne",
      captcha_required: "Potwierdź, że nie jesteś robotem.",
      registration_failed: "Rejestracja nie powiodła się. Spróbuj ponownie.",
      verification_email_resent: "Email weryfikacyjny wysłany ponownie. Sprawdź swoją skrzynkę.",
      unable_to_resend: "Nie można ponownie wysłać emaila weryfikacyjnego.",
      terms_required: "Musisz zaakceptować Warunki korzystania z usługi i Politykę prywatności"
    },
  },
  forgot_password: {
    headline: "Zapomniałeś hasła",
    description: "Wprowadź swój e-mail, aby zresetować hasło.",
  },
  start_message: {
    headline: "Rozpocznij swoją podróż!",
    description: "Wygląda na to, że nie masz jeszcze żadnych celów. Dodaj swój pierwszy cel i rozpocznij niesamowity rok!",
  },
  logout: {
    headline: "Wyloguj się",
  },
  help_center: {
    headline: "Centrum pomocy",
  },
  card_quote: {
    headline: "Cytat",
    description: "Cytat, który zainspiruje Cię i ukształtuje Twój nadchodzący rok",
    popup: {
      delete_title: "Usuń",
      delete_description: "Czy na pewno chcesz trwale usunąć ten cytat?",
      edit_title: "Edytuj cytat",
      add_title: "Napisz cytat na"
    },
    form: {
      label: "Cytat",
      placeholder: "Zacznij tam, gdzie jesteś. Użyj tego, co masz. Rób, co możesz."
    }
  },
  card_theme: {
    headline: "Temat",
    description: "Twój główny obszar do priorytetyzowania w tym roku",
    popup: {
      delete_title: "Usuń",
      delete_description: "Czy na pewno chcesz trwale usunąć ten temat?",
      edit_title: "Edytuj temat",
      add_title: "Napisz temat na"
    },
    form: {
      label: "Temat",
      placeholder: "Priorytetem jest rozwój zawodowy — zdobywanie nowych umiejętności, networking i odważne kroki naprzód."
    }
  },  
  card_letter: {
    headline: "List do siebie z przyszłości",
    description: "Napisz list, w którym zastanowisz się nad swoim rozwojem w nadchodzącym roku",
    button: "Otwórz list do końca",
    popup: {
      delete_title: "Usuń",
      delete_description: "Czy na pewno chcesz trwale usunąć ten list?",
      edit_title: "Edytuj list",
      add_title: "Napisz list do siebie z przyszłości",
      view_title: "List do siebie z przyszłości"
    },
    form: {
      label_title: "Nagłówek",
      placeholder_title: "Do osoby, którą się stanę — List dla Ciebie",
      label_text: "List",
      placeholder_text: "Chcę, żebyś wiedział(a), że robię wszystko, co w mojej mocy, być najlepszą wersją siebie i mam nadzieję, że kontynuujesz tę drogę. Bez względu na to, dokąd zaprowadziło Cię życie, pamiętaj o wartościach, które zawsze były dla Ciebie ważne. Nie trać z oczu tego, co naprawdę się liczy."
    }
  },
  card_note: {
    headline: "Codzienne myśli",
    description: "Przestrzeń do codziennej refleksji i rozwoju",
    popup: {
      delete_title: "Usuń",
      delete_description: "Czy na pewno chcesz trwale usunąć tę notatkę?",
      edit_title: "Edytuj notatkę",
      add_title: "Napisz codzienną notatkę",
      view_title: "Zobacz codzienną notatkę"
    },
    form: {
      label_date: "Data",
      label_title: "Nagłówek",
      placeholder_title: "Małe rzeczy, które dziś się wydarzyły",
      label_text: "Notatka",
      placeholder_text: "Dziś nauczyłem/am się czegoś o sobie. Uświadomiło mi to, jak bardzo się rozwinąłem/am."
    }
  },
  card_goal: {
    headline: "Cele",
    description: "Pozostań skoncentrowany i na właściwej drodze do swoich celów"
  },
  card_progress: {
    headline: "Postęp",
    description: "Śledź swoje zadania i świętuj zwycięstwa"
  },
  card_milestone: {
    headline: "Kamienie milowe",
    description: "Śledź codzienne zadania do zrobienia",
    fallback_text: "Brak zaplanowanych zadań na dziś. Odpocznij — jesteś na dobrej drodze!",
    popup: {
      delete_title: "Usuń",
      delete_description: "Czy na pewno chcesz trwale usunąć ten kamień milowy?",
      edit_title: "Edytuj kamień milowy",
    },
    form: {
      label_title: "Tytuł",
      label_deadline: "Termin",
      label_status: "Zrealizowane"
    }
    

  },
  card_wishlist: {
    headline: "Lista życzeń",
    description: "Pozostań skoncentrowany i trzymaj się swoich celów",
    button: "Dodaj życzenie",
    button_file: "Wybierz plik",

    popup: {
      delete_title: "Usuń",
      delete_description: "Czy na pewno chcesz trwale usunąć to życzenie?",
      edit_title: "Edytuj życzenie",
      add_title: "Dodaj życzenie"
    },
    form: {
      label_title: "Moje życzenie",
      placeholder_title: "Nowy MacBook Pro",
      label_img: "Prześlij obraz",
      label_link: "Link",
      placeholder_link: "https://example.com",
      label_price: "Cena",
      placeholder_price: "299",
      label_currency: "Waluta",
      placeholder_currency: "PLN"
    }
  },
  dropdown: {
    add: "Dodaj",
    edit: "Edytuj",
    delete: "Usuń",
    view: "Zobacz",
    view_all: "Zobacz wszystkie",
    cancel: "Anuluj",
    close: "Zamknij",
    save: "Zapisz",
    update: "Aktualizuj",
    link_shop: "Link do sklepu",
    bought: "Kupione",
    read_more: "Czytaj więcej"

  },
  tab: {
    title_1: "Cele i postępy",
    title_2: "Kamienie milowe i dziennik",
    title_3: "Lista życzeń"
  },
  metrics: {
    total: "Wszystkie cele",
    progress: "W trakcie",
    completed: "Zrealizowane",
    fav: "Mój wielki cel na",
    popup: {
      edit_title: "Edytuj mój wielki cel na",
      edit_description: "Wybierz jeden najważniejszy cel na ten rok i uczyń go priorytetem"
    }
    
  },
  calendar: {
    upcoming: "Nadchodzące",
    completed: "Zrealizowane",
    today: "Dzisiaj",
    mon: "Pon",
    tue: "Wt",
    wed: "Śr",
    thu: "Czw",
    fri: "Pt",
    sat: "Sob",
    sun: "Ndz"
  },
  addgoal: {
    milestone_title: "Kamienie milowe",
    milesone_description: "Podziel swój cel na praktyczne zadania",
    button_milestone: "Dodaj kamień milowy",
  
    toggle_title: "Jak ustawić swoje cele S.M.A.R.T?",
  
    form: {
      label_title: "Ustaw cel",
      placeholder_title: "Podróż do Paryża na tydzień",
      label_img: "Prześlij obrazek reprezentujący cel",
      label_deadline: "Ustaw termin",
      placeholder_deadline: "Wybierz lub wpisz termin, np.: 2026, 2027 itd.",
      label_category: "Wybierz kategorię",
      placeholder_category: "Wybierz lub wpisz kategorię, np.: Zdrowie, Kariera, Finanse, Rozwój osobisty itd.",
      label_fav: "Ustaw jako cel roczny",
      placeholder_fav: "Ta jedna wielka rzecz, do której dążę:",
      label_milestone_title: "Ustaw kamień milowy",
      label_milestone_placeholder: "Zarezerwuj bilety lotnicze",
      label_milestone_deadline: "Ustaw termin",
      label_milestone_repeat: "Powtarzaj",
      label_milestone_select: "Wybierz opcję",
      label_milestone_repeat_1: "Codziennie",
      label_milestone_repeat_2: "Co tydzień",
      label_milestone_repeat_3: "Co miesiąc",
    }
  }
  

  
  
  
  
  
};

export default pl;
